<template>
  <div class="pa-select-search" v-if="formatted">
    <label for="">Search</label>
    <input
      type="text"
      v-model="item"
      @input="changeAutoComplete(true)"
      @focusin="changeAutoComplete(true)"
      @focusout="changeAutoComplete(false)"
    />

    <ul
      class="pa-select-search-items"
      v-show="autocomplete && !!formatted.length"
    >
      <li
        class="pa-select-search-item"
        v-for="item in formatted"
        :key="item"
        @click="setItem(item)"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    input: String,
  },
  data() {
    return {
      item: null,
      autocomplete: false,
    };
  },
  computed: {
    formatted() {
      if (!this.items) return [];
      if (!this.item) return this.items;
      return this.items.filter((m) => m.includes(this.item));
    },
  },
  methods: {
    changeAutoComplete(value) {
      setTimeout(() => (this.autocomplete = value), 200);
    },
    setItem(item) {
      this.item = item;
      this.$emit("input", item);
      this.autocomplete = false;
    },
  },
  mounted() {
    this.item = this.input;
  },
};
</script>

<style lang="scss" scoped>
.pa-select-search {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;

  .pa-select-search-items {
    position: absolute;
    top: 50px;
    height: 300px;
    overflow: auto;
    width: 100%;
    list-style: none;
    padding: 6px 12px;
    background: #fff;
    border-bottom: 1px solid;

    .pa-select-search-item {
      cursor: pointer;
      &:hover {
        background: rgba($color: #000000, $alpha: 0.5);
      }
    }
  }
}
</style>
